export default __webpack_public_path__ + "static/media/ic-embed-link.e2811069.svg";